import { defineComponent } from "vue";

/**
 * 渲染 `Page403` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Page403 = defineComponent({
	name: "Page403",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
				<path
					d="M55.48 273.73s2.32 72 62.43 120 143.41 51.43 210.84 56 119.23-33.62 127-91.32-43.72-74.64-71.68-140.33-25.43-87.28-84.58-127.68S147.8 74.81 99.29 144 55.48 273.73 55.48 273.73z"
					fill="#409eff"
				/>
				<path
					d="M55.48 273.73s2.32 72 62.43 120 143.41 51.43 210.84 56 119.23-33.62 127-91.32-43.72-74.64-71.68-140.33-25.43-87.28-84.58-127.68S147.8 74.81 99.29 144 55.48 273.73 55.48 273.73z"
					fill="#fff"
					opacity=".7"
				/>
				<g fill="none" stroke="#263238" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.166">
					<path d="M83.61 179.69v-25.77c0-18.24 15.16-33.08 33.79-33.08s33.79 14.84 33.79 33.08v25.77h13.47v-25.77c0-25.51-21.2-46.27-47.26-46.27s-47.26 20.76-47.26 46.27v25.77zM65.14 179.87h103.18v85.35H65.14z" />
					<path d="M127.46 215.32a11.24 11.24 0 0 0-22.47 0 11 11 0 0 0 5.9 9.68L109 244.38h14.45L121.56 225a11 11 0 0 0 5.9-9.68z" />
				</g>
				<path
					fill="#263238"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
					d="M232.64 267.99l-25.69-1.69v-.42l-3.16.21-3.15-.21v.42l-25.69 1.69L156 423.79h18.95l28.21-124.22h1.27l28.21 124.22h18.95l-18.95-155.8z"
				/>
				<path
					d="M156 423.78l-4.63 7.16-14.32 6.32a4.88 4.88 0 0 0-2.52 4.21v5.47h40.84a54.21 54.21 0 0 0 0-8.84c-.42-4.21-.42-14.32-.42-14.32z"
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M134.53 442.31v4.63h40.84s.19-2 .19-4.63z"
					fill="#263238"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M251.51 423.78l4.63 7.16 14.32 6.32a4.88 4.88 0 0 1 2.52 4.21v5.47h-40.84a54.21 54.21 0 0 1 0-8.84c.42-4.21.42-14.32.42-14.32z"
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M273 442.31v4.63h-40.86s-.18-2-.19-4.63z"
					fill="#263238"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M164.07 195.51s-30 42.16-30 45.25 4.77 26.95 12.35 29.19 11.79-1.68 13.19-9.54-3.37-19.09-3.37-19.09l14-12.63z"
					fill="#409eff"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M158.25 259.29s8.7-1.41 10.95-.85 3.93 5.9 3.93 5.9.84 7.86-.57 9.54-8.14 3.65-10.94 4.21-8.71-5.89-11-9.82 1.73-10.67 7.63-8.98z"
					fill="#ccc"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					fill="#409eff"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
					d="M170.38 193.6l-6.31 1.91 9.94 66.35h59.08l8.99-65.97-8.03-3.06-29.64-6.5-34.03 7.27z"
				/>
				<path
					fill="#263238"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
					d="M236.34 215.78l-1.33 9.56-10.33 2.48-10.52-4.2.77-8.61 21.41.77z"
				/>
				<circle
					cx="225.35"
					cy="223.52"
					r="1.82"
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					fill="#263238"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
					d="M198.1 198.57l5.55 6.5-7.08 45.12 7.46 11.86 8.8-12.43-7.46-44.36 6.31-6.12-6.69-8.6-6.89 8.03zM192.75 187.29l-25.43 6.31.77 3.06 24.85-6.89-.19-2.48zM213.59 186.52l25.43 6.31-.76 3.06-24.86-6.88.19-2.49z"
				/>
				<path
					d="M239 192.83s9.62 2.17 15.51 5.54 7.3 10.95 3.93 19.37-13.75 7.3-18.52 5-6.18-10.66-5.34-14.31M193.9 184.04l-2.87 1.91.76 19.31 12.43-8.79 13 8.98 1.15-19.12-3.44-2.87-21.03.58z"
					fill="#409eff"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M219 161.07s7.06-1.72 8.39-8.78-11.39-15.65-20.21-17.17-21.75 7.63-23.85 13.93 6.1 12.59 14.88 13.93 20.79-1.91 20.79-1.91z"
					fill="#263238"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M192.68 162.22s-3.82-5.92-4.77-.77 3.05 7.44 4.77 7.25 0-6.48 0-6.48zM217.49 162.22s3.82-5.92 4.77-.77-3 7.44-4.77 7.25 0-6.48 0-6.48zM193.52 173.9v12.62l10.7 9.95 12.05-10.33v-11.85l-22.75-.39z"
					fill="#ccc"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M191.92 158.4s-.58 11.83.38 15.65 7.25 11.83 12.21 13.55 11.83-8.59 13.36-12 .95-17.94.95-17.94-2.09-5-6.29-6.48-17.18-4.18-20.61 7.22z"
					fill="#ccc"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M199.85 164.68c0 .9-.41 1.63-.92 1.63s-.92-.73-.92-1.63.41-1.63.92-1.63.92.73.92 1.63zM211.56 164.68c0 .9-.41 1.63-.92 1.63s-.92-.73-.92-1.63.41-1.63.92-1.63.92.73.92 1.63z"
					fill="#263238"
				/>
				<path
					d="M201.84 169.24a1.28 1.28 0 1 0 0 2.49 1.74 1.74 0 0 0 1.11-.37 3.21 3.21 0 0 0 4.82.08 1.8 1.8 0 0 0 1 .29 1.28 1.28 0 1 0 0-2.49M203.36 177.07h3.99"
					fill="#ccc"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M191.48 161.27s.14 3.84 1.42 2.84 1.7-7.52.57-8.37-1.99 3.55-1.99 5.53zM216.11 161.27s.15 3.84 1.42 2.84 1.71-7.52.57-8.37-1.99 3.55-1.99 5.53z"
					fill="#263238"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M191.48 158.15s.43.35.42.52c1.85 1 6.1 2.84 13 3.21a26.56 26.56 0 0 0 14-3.43v-.82c-.17-4.47-3.49-7.45-7.6-8.59a19.57 19.57 0 0 0-12.24.61 12 12 0 0 0-5.07 3.65c-.51.56-3.21 4.29-2.51 4.85z"
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M191.92 158.4a45.19 45.19 0 0 0 13 .95c8.21-.38 13.92-.95 13.92-.95a22.64 22.64 0 0 1-13.8 6.06 15.14 15.14 0 0 1-13.12-6.06z"
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					fill="#263238"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
					d="M170.96 215.78l1.33 9.56 10.33 2.48 10.51-4.2-.76-8.61-21.41.77z"
				/>
				<circle
					cx="181.95"
					cy="223.52"
					r="1.82"
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
					d="M173.13 261.25h60.63v9.54h-60.63z"
				/>
				<rect
					x="168.92"
					y="261.81"
					width="18.53"
					height="11.79"
					rx="2.67"
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<rect
					x="217.2"
					y="261.81"
					width="18.53"
					height="11.79"
					rx="2.67"
					fill="#4c4c4c"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					fill="#fff"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
					d="M197.83 261.81h13.19v8.42h-13.19z"
				/>
				<path
					d="M156.28 241.32s-8.42-.56-11.51-5.9"
					fill="none"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<ellipse
					cx="249.9"
					cy="202.02"
					rx="13.9"
					ry="14.6"
					fill="#409eff"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<ellipse
					cx="249.9"
					cy="194.63"
					rx="10.88"
					ry="9.75"
					fill="#409eff"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<ellipse
					cx="249.9"
					cy="187.46"
					rx="10.88"
					ry="9.75"
					fill="#ccc"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					d="M232.42 166.44s.19 14.38.92 18.62 3.69 9.77 7.75 9.77a25.53 25.53 0 0 0 7.93-1.47s4.79 2.58 9.4 1.84 3.87-7.19 3.87-10-.55-23.6-.55-23.6.37-2-1.48-2.39a15.8 15.8 0 0 0-2.76-.37v-4.43a3.36 3.36 0 0 0-3.14-1.47c-2.39 0-2.58.55-2.58.55v-4.06s-2-3.23-4.61-1.66a3.68 3.68 0 0 0-1.84 2.95l-.19 3.88s-4.42-1.66-4.79.92-1.11 18.48-1.11 18.48a40.86 40.86 0 0 0-1.47-7.38c-.92-2.4-5.35-2.4-5.35-.18z"
					fill="#ccc"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
				/>
				<path
					fill="none"
					stroke="#263238"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.166"
					d="M245.14 154.64l.37 16.96M251.78 153.53l.19 18.25M257.5 158.88l-.37 12.72M242.75 171.42l16.78.73M239.24 174a4.51 4.51 0 0 0 1.81 3.58c1.82 1.14 5.92 4.1 6.37 8.88"
				/>
				<g fill="#263238">
					<path d="M350 128.81V131h-5.33v7.76h6.55V141h-9v-21.8h9v2.21h-6.55v7.44zM358.3 119.16c3.42 0 4.86 1.74 4.86 5v1.78c0 2.4-.84 3.89-2.71 4.48 2 .59 2.74 2.21 2.74 4.55v3.4a5.49 5.49 0 0 0 .43 2.61h-2.46a5.7 5.7 0 0 1-.4-2.64v-3.43c0-2.46-1.15-3.24-3.18-3.24h-1.71V141h-2.43v-21.8zm-.63 10.28c1.94 0 3.09-.63 3.09-3v-2.09c0-2-.72-3-2.52-3h-2.37v8.07zM370.57 119.16c3.43 0 4.86 1.74 4.86 5v1.78c0 2.4-.84 3.89-2.71 4.48 2 .59 2.74 2.21 2.74 4.55v3.4a5.37 5.37 0 0 0 .44 2.61h-2.46a5.66 5.66 0 0 1-.41-2.64v-3.43c0-2.46-1.15-3.24-3.18-3.24h-1.71V141h-2.43v-21.8zm-.57 10.28c1.93 0 3.08-.63 3.08-3v-2.09c0-2-.71-3-2.52-3h-2.37v8.07zM377.8 124.42c0-3.33 1.65-5.48 5-5.48s5 2.15 5 5.48v11.28c0 3.3-1.65 5.48-5 5.48s-5-2.18-5-5.48zm2.4 11.4c0 2 .84 3.15 2.58 3.15s2.59-1.15 2.59-3.15V124.3c0-2-.81-3.15-2.59-3.15s-2.58 1.18-2.58 3.15zM395 119.16c3.43 0 4.86 1.74 4.86 5v1.78c0 2.4-.84 3.89-2.71 4.48 2 .59 2.74 2.21 2.74 4.55v3.4a5.37 5.37 0 0 0 .44 2.61h-2.46a5.66 5.66 0 0 1-.41-2.64v-3.43c0-2.46-1.15-3.24-3.18-3.24h-1.71V141h-2.47v-21.8zm-.62 10.28c1.93 0 3.08-.63 3.08-3v-2.09c0-2-.71-3-2.52-3h-2.37v8.07zM329.38 264.88v2.21h-5v9.44h-2.43v-21.8h8.66v2.21h-6.23v7.94zM332.33 260c0-3.33 1.66-5.48 5-5.48s5 2.15 5 5.48v11.28c0 3.3-1.65 5.48-5 5.48s-5-2.18-5-5.48zm2.4 11.4c0 2 .84 3.15 2.59 3.15s2.58-1.15 2.58-3.15v-11.53c0-2-.81-3.15-2.58-3.15s-2.59 1.18-2.59 3.15zM349.5 254.73c3.42 0 4.86 1.74 4.86 5v1.78c0 2.4-.84 3.89-2.71 4.48 2 .59 2.74 2.21 2.74 4.55v3.4a5.37 5.37 0 0 0 .44 2.61h-2.46a5.53 5.53 0 0 1-.41-2.64v-3.43c0-2.46-1.15-3.24-3.18-3.24h-1.71v9.31h-2.43v-21.8zm-.62 10.27c1.93 0 3.08-.63 3.08-3v-2.09c0-2-.72-3-2.52-3h-2.37V265zM361.8 254.73c3.4 0 4.74 1.62 4.74 4.83v1c0 2.31-.66 3.74-2.56 4.33 2.12.6 2.93 2.28 2.93 4.68v1.83c0 3.28-1.59 5.11-5 5.11h-5v-21.8zm-.59 9.25c1.93 0 2.93-.62 2.93-2.9v-1.28c0-1.93-.66-2.86-2.4-2.86h-2.4v7zm.72 10.34c1.77 0 2.58-.93 2.58-3v-1.93c0-2.43-1-3.24-3.05-3.24h-2.12v8.13zM371.55 254.73v21.8h-2.43v-21.8zM379.15 254.73c3.4 0 5 2 5 5.42v11c0 3.34-1.56 5.39-5 5.39h-5.1v-21.8zm0 19.59c1.75 0 2.59-1.09 2.59-3.08V260c0-2-.84-3.08-2.62-3.08h-2.62v17.38zM391.49 254.73c3.39 0 4.95 2 4.95 5.42v11c0 3.34-1.56 5.39-4.95 5.39h-5.11v-21.8zm0 19.59c1.74 0 2.58-1.09 2.58-3.08V260c0-2-.84-3.08-2.61-3.08h-2.62v17.38zM406.47 264.38v2.18h-5.33v7.76h6.55v2.21h-9v-21.8h9v2.21h-6.55v7.44zM412.08 276.53h-2.18v-21.8h3.1l5 15.76v-15.76h2.15v21.8h-2.53l-5.57-17.63zM306.54 208.26l22.25-52.61h13.35v52.61h5.78v11.12h-5.78v14.12h-12v-14.12h-23.6zm23.58 0V179l-12.34 29.25zM352.48 174.33c0-12.45 6.56-19.57 18.57-19.57s18.58 7.12 18.58 19.57v40.49c0 12.46-6.57 19.57-18.58 19.57s-18.57-7.11-18.57-19.57zm12.23 41.27c0 5.56 2.45 7.67 6.34 7.67s6.34-2.11 6.34-7.67v-42c0-5.57-2.44-7.68-6.34-7.68s-6.34 2.11-6.34 7.68zM421.1 174.78c0-7-2.44-8.9-6.34-8.9s-6.34 2.11-6.34 7.68v5h-11.56v-4.23c0-12.45 6.22-19.57 18.24-19.57s18.24 7.12 18.24 19.57v2c0 8.34-2.67 13.57-8.57 16 6.12 2.67 8.57 8.45 8.57 16.35v6.12c0 12.46-6.23 19.57-18.24 19.57s-18.24-7.11-18.24-19.57v-6.45h11.56v7.23c0 5.56 2.45 7.67 6.34 7.67s6.34-1.89 6.34-8.78v-6.12c0-7.23-2.44-9.9-8-9.9H409v-11.1h4.78c4.56 0 7.34-2 7.34-8.23z" />
				</g>
				<g>
					<path
						fill="#263238"
						stroke="#263238"
						stroke-miterlimit="10"
						stroke-width="1.166"
						d="M86.87 446.5H72.61l19.01-132.51h14.26L86.87 446.5z"
					/>
					<path
						fill="#fff"
						stroke="#263238"
						stroke-miterlimit="10"
						stroke-width="1.166"
						d="M115.39 446.5h14.25l-19.01-132.51H96.38l19.01 132.51z"
					/>
					<path
						fill="#263238"
						stroke="#263238"
						stroke-miterlimit="10"
						stroke-width="1.166"
						d="M289.18 446.5h-14.25l19-132.51h14.26L289.18 446.5z"
					/>
					<path
						fill="#fff"
						stroke="#263238"
						stroke-miterlimit="10"
						stroke-width="1.166"
						d="M317.7 446.5h14.25l-19.01-132.51h-14.25L317.7 446.5z"
					/>
					<path fill="#409eff" stroke="#263238" stroke-miterlimit="10" stroke-width="1.166" d="M55.73 293.21h271.93v26.36H55.73z" />
					<path fill="#409eff" stroke="#263238" stroke-miterlimit="10" stroke-width="1.166" d="M62.36 293.21h271.93v26.36H62.36z" />
					<path
						fill="#263238"
						d="M66.81 319.57h23.08l11.93-26.36H78.74l-11.93 26.36zM158.17 293.21h-23.08l-11.93 26.36h23.08l11.93-26.36zM327.21 293.21h-23.08l-11.92 26.36h23.08l11.92-26.36zM270.87 293.21h-23.09l-11.92 26.36h23.08l11.93-26.36zM214.52 293.21h-23.08l-11.93 26.36h23.08l11.93-26.36z"
					/>
					<path
						fill="none"
						stroke="#263238"
						stroke-miterlimit="10"
						stroke-width="1.166"
						d="M332.8 304.9h-45M332.01 309.31h-7.1M61.21 308.21h45M62 303.25h56.84"
					/>
					<path
						fill="#263238"
						stroke="#263238"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.166"
						d="M331.37 440.72h77.14v5.79h-77.14z"
					/>
					<path
						fill="#409eff"
						stroke="#263238"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.166"
						d="M395.49 440.56h-51.1l20.03-108.96h11.04l20.03 108.96z"
					/>
					<path
						fill="#fff"
						stroke="#263238"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.166"
						d="M356.98 372.1h25.93l-2.49-13.5h-20.96l-2.48 13.5z"
					/>
					<path
						fill="#409eff"
						stroke="#263238"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.166"
						d="M387.81 422.37l1.28 7.45M373.22 337.62L386.2 413"
					/>
				</g>
				<g fill="none" stroke="#263238" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.166">
					<path d="M450.01 446.5h6.91M39.37 446.5h400.99" />
				</g>
			</svg>
		);
	},
});

export default Page403;
